import { useContext, useEffect, useState } from "react";
import { config, searchRegex } from "../../../../constant";
import { useElement, useLocale, useService } from "../../../../hooks";
import { AppContext, NavigatorContext } from "../../../../context";

export const useSocieties = ({ param }) => {
  const { t } = useLocale();
  const Actor = useElement("Actor");
  const CheckBox = useElement("CheckBox");
  const { commonPageSize } = config;
  const { getLoggedInUserData } = useService("User");
  const { setTitle } = useService("Meta");
  const { getSocieties, deleteSociety } = useService("Location");
  const { actions: { showPreloader, hidePreloader } } = useContext(AppContext);
  const { showAlert, isBottom } = useService("Misc");
  const { navigateTo } = useContext(NavigatorContext);
  const user = getLoggedInUserData();
  const [tableContent, settableContent] = useState(null);
  const [activeShownTotal, setactiveShownTotal] =
    useState<number>(commonPageSize);
  const [tableData, settableData] = useState(param);
  const [showTrashConfirm, setshowTrashConfirm] = useState<boolean>(false);
  const [checkedAll, setcheckedAll] = useState<boolean>(false);
  const [activeItem, setactiveItem] = useState(null);
  const [filteredList, setfilteredList] = useState([]);
  const [checkedList, setcheckedList] = useState([]);
  const [isMultipleDelete, setisMultipleDelete] = useState<boolean>(false);
  const [searchKey, setsearchKey] = useState<string>("");

  setTitle(t("socitiesList"), "admin");
  useEffect(() => {
    getSocietiesListData();
  }, []);

  const trackScrolling = () => {
    const wrappedElement = document.getElementById("list-wrapper");
    if (isBottom(wrappedElement)) {
      if (
        filteredList.length > commonPageSize &&
        activeShownTotal < filteredList.length
      )
        showMore();
    }
  };

  const showMore = () => {
    showPreloader();
    setTimeout(() => {
      hidePreloader();
      setactiveShownTotal(activeShownTotal + commonPageSize);
    }, 300);
  };

  const resetSearch = () => {
    setfilteredList(tableData);
    setsearchKey("");
  };

  const getSocietiesListData = async () => {
    const result = await getSocieties();
    if (result.status) {
      let tableData = result.data;
      settableData(tableData);
      setfilteredList(tableData);
      if (result.data?.length === 0)
        showAlert({ type: "error", msg: "No society added yet!" });
    } else showAlert({ type: "error", msg: "No society added yet!" });
  };

  const getTableData = (filterData) => {
    let data = [];
    filterData.map((item) => {
      let found = user.role !== "supervisor";
      if (item.supervisor && !found) {
        item.supervisor = JSON.parse(item.supervisor);
        if (item.supervisor !== '""') {
          found = item.supervisor.value === user.uid;
        }
      }
      if (found) {
        let e = {
          checkAction: (
            <span className="check-all" onClick={() => toggleCheck(item.uid)}>
              {checkedAll || checkedList.includes(item.uid) ? (
                <i className="orange hi-check-circle"></i>
              ) : (
                <i className="hi-circle"></i>
              )}
            </span>
          ),
          title: item.title,
          address: item.address,
          action: (
            <div className="action-bar">
              {user.role !== "supervisor" && (
                <>
                  <Actor
                    type="trash"
                    onClick={() => {
                      setactiveItem(item);
                      setshowTrashConfirm(true);
                    }}
                  />
                  <Actor
                    type="edit"
                    onClick={() =>
                      navigateTo({ route: "/admin/society/edit/" + item.uid })
                    }
                  />
                </>
              )}
            </div>
          ),
        };
        data.push(e);
      }
    });
    return data;
  };

  const trashCancel = () => {
    setactiveItem(null);
    setshowTrashConfirm(false);
  };

  const deleteSelectSociety = () => {
    deleteSocieties(activeItem.uid);
  };

  const deleteSocieties = async (uid) => {
    const result = await deleteSociety({ uid });
    if (result.status) {
      getSocietiesListData();
      showAlert({ type: "success", msg: "Order deleted successfully!" });
      setactiveItem(null);
      setshowTrashConfirm(false);
    } else showAlert({ type: "error", msg: "Unable to delete order!" });
  };

  useEffect(() => {
    setcheckedAll(filteredList.length === checkedList.length);
  }, [filteredList, checkedList]);

  const toggleCheck = (uid) => {
    if (checkedList.includes(uid)) {
      setcheckedList(checkedList.filter((e) => e !== uid));
    } else {
      setcheckedList([...checkedList, uid]);
    }
  };

  const deleteChecked = () => {
    (checkedAll ? filteredList : checkedList).forEach((e) => {
      deleteSocieties(e.uid);
    });
    setcheckedList([]);
    setisMultipleDelete(false);
  };

  const search = (e) => {
    if (e.target.value === "" || searchRegex.test(e.target.value)) {
      setsearchKey(e.target.value);
      let tempTitle = "",
        filteredList = [];
      tableData.forEach((e) => {
        tempTitle = e.title.toLowerCase();
        if (tempTitle.search(searchKey) !== -1) filteredList.push(e);
      });
      setfilteredList(filteredList);
    }
  };

  useEffect(() => {
    settableContent({
      headers: [
        {
          checkAction: (
            <span
              className="check-all"
              onClick={() => {
                let newCheckedList = [];
                if (checkedAll) {
                  setcheckedAll(!checkedAll);
                  setcheckedList([]);
                } else {
                  filteredList.forEach((e) => newCheckedList.push(e.uid));
                  setcheckedAll(!checkedAll);
                  setcheckedList(newCheckedList);
                }
              }}
            >
              <CheckBox
                isChecked={
                  checkedAll ||
                  (checkedList.length === filteredList.length &&
                    filteredList.length !== 0)
                }
              />
            </span>
          ),
        },
        {
          label: t("title"),
          key: "title",
        },
        {
          label: "Address",
          key: "address",
        },
        {
          label: t("actions"),
          key: "actions",
        },
      ],
      content: getTableData(filteredList),
    });
  }, [filteredList, checkedAll, checkedList]);
  return {
    trackScrolling,
    checkedList,
    checkedAll,
    setisMultipleDelete,
    setshowTrashConfirm,
    searchKey,
    search,
    resetSearch,
    tableContent,
    activeShownTotal,
    deleteChecked,
    deleteSelectSociety,
    trashCancel,
    showTrashConfirm,
    isMultipleDelete,
  };
};
